module.exports = __webpack_public_path__ + "static/timer-7b96f626ade3f6a1213c6bbb0e90cb51.jpg";